import Seo from "@/lib/Seo";
import PageHero from "@/components/common/PageHero";
import { LEGAL, CONTACTS, QUALIOPI } from "@/data/site";

const Row = ({ label, children }) => (
  <div className="flex flex-col gap-0.5 border-b border-slate-100 py-3 sm:flex-row sm:gap-4">
    <span className="w-full shrink-0 font-medium text-brand-blue sm:w-64">{label}</span>
    <span>{children}</span>
  </div>
);

export default function MentionsLegales() {
  return (
    <>
      <Seo title="Mentions légales" description="Mentions légales du site EDUCASER GROUP (NTER FORMATIONS SECURITE ROUTIERE)." path="/mentions-legales" />
      <PageHero
        breadcrumb={[{ label: "Accueil", to: "/" }, { label: "Mentions légales" }]}
        title="Mentions légales"
      />
      <div className="bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-3xl space-y-10 px-5 text-slate-600 lg:px-8">
          <section>
            <h2 className="font-display text-xl font-bold text-brand-blue">Éditeur du site</h2>
            <div className="mt-4 text-sm">
              <Row label="Raison sociale">{LEGAL.raisonSociale}</Row>
              <Row label="Enseigne commerciale">{LEGAL.enseigne}</Row>
              <Row label="Forme juridique">{LEGAL.formeJuridique}</Row>
              <Row label="Capital social">{LEGAL.capital}</Row>
              <Row label="Siège social">{LEGAL.siege}</Row>
              <Row label="SIREN">{LEGAL.siren}</Row>
              <Row label="SIRET (siège)">{LEGAL.siret}</Row>
              <Row label="RCS">{LEGAL.rcs}</Row>
              <Row label="Code NAF / APE">{LEGAL.naf}</Row>
              <Row label="N° TVA intracommunautaire">{LEGAL.tva}</Row>
              <Row label="Président / Directeur de la publication">{LEGAL.president}</Row>
              <Row label="Date de création">{LEGAL.creation}</Row>
            </div>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-blue">Certifications et agréments</h2>
            <div className="mt-4 text-sm">
              <Row label="N° de déclaration d'activité (NDA)">{LEGAL.nda}</Row>
              <Row label="Certification qualité">Qualiopi — {QUALIOPI.perimetre}</Row>
              <Row label="Agréments">
                Agréments délivrés par les autorités compétentes (préfecture, DREAL, DRIEETS) selon les
                formations.
              </Row>
            </div>
            <p className="mt-3 text-xs text-slate-400">
              La certification qualité a été délivrée au titre de la catégorie d'actions suivante :
              Actions de formation.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-blue">Contact</h2>
            <div className="mt-4 text-sm">
              <Row label="Téléphone">{CONTACTS.enseignants.telephone} · {CONTACTS.groupeLourd.telephone}</Row>
              <Row label="E-mail">{CONTACTS.enseignants.email}</Row>
              <Row label="Adresse">{LEGAL.siege}</Row>
            </div>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-blue">Hébergement</h2>
            <p className="mt-3 text-sm">
              Le site est hébergé par {LEGAL.hebergeur}.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-brand-blue">Propriété intellectuelle</h2>
            <p className="mt-3 text-sm">
              L'ensemble des contenus de ce site (textes, images, logo, vidéos) est protégé par le droit
              de la propriété intellectuelle. Toute reproduction, représentation ou diffusion, totale ou
              partielle, sans autorisation préalable est interdite.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}
